<div class="main-content">
  <div class="container-fluid">
    <div class="meeting-step-header">
      <h4>First Meeting</h4>
      <p class="meeting-step-subtitle">
        Schedule the kick-off call with the project, share the contact e-mail template, then mark the meeting as completed.
      </p>
    </div>

    <router-outlet *ngIf="!loading" name="meeting_1"></router-outlet>
  </div>
</div>
